import { gql } from "@apollo/client";

export const ORG_ACCOUNT_TRANSFER = gql`
  mutation SpendOrganizationAccountTransfer(
    $input: SpendAccountTransferInput!
  ) {
    spendOrganizationAccountTransfer(input: $input) {
      id
      status
      reason
      approvalId
    }
  }
`;

export const ORG_EXTERNAL_TRANSFER = gql`
  mutation SpendOrganizationExternalTransfer(
    $input: SpendOrganizationExternalTransferInput!
  ) {
    spendOrganizationExternalTransfer(input: $input) {
      amount
      descriptor
      id
      status
    }
  }
`;

export const DELETE_ORG_COUNTERYPARTY = gql`
  mutation SpendOrganizationCounterpartyDelete($counterpartyId: String!) {
    spendOrganizationCounterpartyDelete(counterpartyId: $counterpartyId) {
      success
    }
  }
`;

export const ORG_ACH_CREDIT = gql`
  mutation SpendOrganizationACHCredit($input: SpendOrgACHCredit) {
    spendOrganizationACHCredit(input: $input) {
      paymentId
      approvalId
    }
  }
`;

export const CREATE_ORG_COUNTERPARTY = `
  mutation SpendOrganizationCounterpartyCreate(
    $vgsInput: SpendCounterpartyCreateInput
  ) {
    spendOrganizationCounterpartyCreate(input: $vgsInput) {
      id
    }
  }
`;

export const SEND_ORG_CHECK = gql`
  mutation SpendOrganizationCheckSend($input: SpendCheckInput!) {
    spendOrganizationCheckSend(input: $input) {
      id
      type
      approvalId
      status
    }
  }
`;

export const UPDATE_ORG_PAYEE = gql`
  mutation SpendOrganizationPayeeUpdate($input: SpendPayeeUpdateInput!) {
    spendOrganizationPayeeUpdate(input: $input) {
      payeeId
    }
  }
`;

export const CREATE_ORG_PAYEE = `
  mutation SpendOrganizationPayeeCreate($vgsInput: SpendPayeeInput!) {
    spendOrganizationPayeeCreate(input: $vgsInput) {
      payeeId
    }
  }
`;

export const CREATE_ORG_DEBIT_CARD_STRING = `
  mutation SpendOrganizationDebitCardCreate($vgsInput: SpendDebitCardInput!) {
    spendOrganizationDebitCardCreate(input: $vgsInput) {
      id
      approvalId
    }
  }`;
